// extracted by mini-css-extract-plugin
export default {"AssignChecklist":"AttachResourcesPopup_AssignChecklist__d88xT","modalBody":"AttachResourcesPopup_modalBody__6lzZ3","formControl":"AttachResourcesPopup_formControl__j4oZZ"};